// import React, { useState } from "react";
// import axios from "axios";
// import { IoMdClose } from "react-icons/io";
// import { FaUserGraduate, FaLaptopCode, FaCalculator } from "react-icons/fa";

// const ApplicationModal = ({ isOpen, onClose, courseId }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     experience: "",
//   });

//   const [isChecked, setIsChecked] = useState(false);

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleCheckboxChange = (e) => {
//     setIsChecked(e.target.checked);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isChecked) {
//       alert("Please agree to the Privacy Policy before submitting.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/inquiry`,
//         formData
//       );

//       const payload = {
//         courses: [courseId],
//       };

//       const token = JSON.parse(localStorage.getItem("token"));

//       const cart = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const checkout = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=IN`,
//         {}, // Empty data object
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       alert("Application submitted successfully!");
//       // Reset form fields
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         experience: "",
//       });
//       setIsChecked(false);
//       onClose(); // Close the modal
//     } catch (error) {
//       console.error("Error submitting application:", error);
//       alert("Failed to submit application. Please try again.");
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl flex items-center relative px-6 py-10 h-[80vh] mt-5">
//         {/* Left Side - Form */}
//         <div className="w-1/2 p-6">
//           {/* Close Button */}
//           <button
//             className="!absolute top-0 bottom-[90%] right-4 text-gray-500"
//             onClick={onClose}
//           >
//             <IoMdClose size={24} />
//           </button>

//           <h2 className="text-xl font-bold text-center text-gray-900">
//             Start Application
//           </h2>
//           <p className="mt-2 text-sm text-center text-gray-600">
//             Please enter the following details to initiate your application for
//             <strong>
//               {" "}
//               Advanced Executive Program In Applied Generative AI
//             </strong>
//             in partnership with IITM Pravartak.
//           </p>

//           {/* Form Fields */}
//           <form className="mt-4 space-y-2" onSubmit={handleSubmit}>
//             <div>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full mt-1 p-2 rounded-lg"
//                 placeholder="Enter your name"
//               />
//             </div>
//             <div>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="w-full mt-1 p-2 rounded-lg"
//                 placeholder="Enter your email"
//               />
//             </div>
//             <div>
//               <div className="flex gap-2">
//                 <select className="w-24 px-2 py-2 border border-gray-300 rounded-md">
//                   <option value="IN">IN +91</option>
//                 </select>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   placeholder="Phone Number*"
//                   className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//                 />
//               </div>
//             </div>
//             <div>
//               <label className="block text-gray-700 font-medium">
//                 Total Work Experience*
//               </label>
//               <select
//                 name="experience"
//                 value={formData.experience}
//                 onChange={handleChange}
//                 className="w-full mt-1 p-2 border rounded-lg"
//               >
//                 <option value="">Select experience</option>
//                 <option value="0">No experience</option>
//                 <option value="1">1-2 years</option>
//                 <option value="3">3-5 years</option>
//                 <option value="5">5+ years</option>
//               </select>
//             </div>

//             {/* Privacy Policy */}
//             <div className="flex items-start">
//               <input
//                 type="checkbox"
//                 checked={isChecked}
//                 onChange={handleCheckboxChange}
//                 className="!mt-1 !w-[10%]"
//               />
//               <span className="text-sm text-gray-600">
//                 By providing your contact details, you agree to our{" "}
//                 <a href="#" className="!text-blue-600 !hover:underline">
//                   Privacy Policy
//                 </a>
//               </span>
//             </div>

//             {/* Proceed Button */}
//             <button
//               type="submit"
//               className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700"
//             >
//               Proceed
//             </button>
//           </form>
//         </div>

//         {/* Right Side - Eligibility */}
//         <div className="w-1/2 p-6 border-l text-sm">
//           <h3 className="text-lg font-bold text-gray-900">
//             Eligible Candidates
//           </h3>
//           <ul className="mt-4 space-y-4">
//             <li className="flex items-center space-x-3">
//               <FaUserGraduate className="text-blue-500 text-xl" />
//               <span>
//                 Have a bachelor's degree with an average of 50 percent or higher
//                 marks
//               </span>
//             </li>
//             <li className="flex items-center space-x-3">
//               <FaLaptopCode className="text-blue-500 text-xl" />
//               <span>
//                 Have a basic understanding of programming concepts and
//                 mathematics
//               </span>
//             </li>
//             <li className="flex items-center space-x-3">
//               <FaCalculator className="text-blue-500 text-xl" />
//               <span>Preferably, have 2+ years of professional experience</span>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ApplicationModal;

// import React, { useState } from "react";
// import axios from "axios";
// import { IoMdClose } from "react-icons/io";
// import { FaUserGraduate, FaLaptopCode, FaCalculator } from "react-icons/fa";
// import logo from "../../../assets/icons/cancel.png";

// const ApplicationModal = ({ isOpen, onClose, courseId }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     experience: "",
//   });

//   const [isChecked, setIsChecked] = useState(false);

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleCheckboxChange = (e) => {
//     setIsChecked(e.target.checked);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isChecked) {
//       alert("Please agree to the Privacy Policy before submitting.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/inquiry`,
//         formData
//       );

//       const payload = {
//         courses: [courseId],
//       };

//       const token = JSON.parse(localStorage.getItem("token"));

//       const cart = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const checkout = await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=IN`,
//         {}, // Empty data object
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       alert("Application submitted successfully!");
//       // Reset form fields
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         experience: "",
//       });
//       setIsChecked(false);
//       onClose(); // Close the modal
//     } catch (error) {
//       console.error("Error submitting application:", error);
//       alert("Failed to submit application. Please try again.");
//     }
//   };

//   return (
//     <div
//       className={`fixed right-0 top-10 h-full w-[90%] md:w-[50%] bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-90 py-4 ${
//         isOpen ? "translate-x-0" : "translate-x-full"
//       }`}
//     >
//       {/* Left Side - Form */}
//       <div className="relative  p-6">
//         {/* Close Button */}
//         <button
//           // className="!absolute top-0 bottom-[90%] right-4 text-gray-500"
//           className={`absolute -left-16 top-4 bg-white rounded-l-full h-10 w-16 shadow-lg ${isOpen ? "translate-x-0" : "translate-x-40"}`}
//           onClick={onClose}
//         >
//           <img src={logo} alt="error" className="h-6 w-6 m-auto" />
//         </button>
//       </div>
//       <div className="px-5 h-full overflow-y-auto pb-20">
//         <h2 className="text-xl font-bold text-center text-gray-900">
//           Start Application
//         </h2>
//         <p className="mt-2 text-sm text-center text-gray-600">
//           Please enter the following details to initiate your application for
//           <strong> Advanced Executive Program In Applied Generative AI</strong>
//           in partnership with IITM Pravartak.
//         </p>

//         {/* Form Fields */}
//         <form className="mt-4 space-y-4" onSubmit={handleSubmit}>
//           <div>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full mt-1 p-2 rounded-lg"
//               placeholder="Enter your name"
//             />
//           </div>
//           <div>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full mt-1 p-2 rounded-lg"
//               placeholder="Enter your email"
//             />
//           </div>
//           <div>
//             <div className="flex gap-2">
//               <select className="w-24 px-2 py-2 border border-gray-300 rounded-md">
//                 <option value="IN">IN +91</option>
//               </select>
//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 placeholder="Phone Number*"
//                 className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//               />
//             </div>
//           </div>
//           <div>
//             <label className="block text-gray-700 font-medium mb-2 ">
//               Total Work Experience*
//             </label>
//             <select
//               name="experience"
//               value={formData.experience}
//               onChange={handleChange}
//               className="w-full mt-1 p-2 border rounded-lg"
//             >
//               <option value="">Select experience</option>
//               <option value="0">No experience</option>
//               <option value="1">1-2 years</option>
//               <option value="3">3-5 years</option>
//               <option value="5">5+ years</option>
//             </select>
//           </div>

//           {/* Privacy Policy */}
//           <div className="flex items-start">
//             <input
//               type="checkbox"
//               checked={isChecked}
//               onChange={handleCheckboxChange}
//               className="!mt-1 !w-[10%]"
//             />
//             <span className="text-sm text-gray-600">
//               By providing your contact details, you agree to our{" "}
//               <a href="#" className="!text-blue-600 !hover:underline">
//                 Privacy Policy
//               </a>
//             </span>
//           </div>

//           <div className="flex justify-end">
//             <button
//               type="submit"
//               className="mt-4 bg-[#264b82] text-white p-2 rounded-lg font-semibold hover:bg-blue-700"
//             >
//               Proceed
//             </button>
//           </div>
//         </form>

//         {/* Right Side - Eligibility */}
//         <div className="w-1/2 p-6 border-l text-sm mt-5">
//           <h3 className="text-lg font-bold text-gray-900">
//             Eligible Candidates
//           </h3>
//           <ul className="mt-4 space-y-4">
//             <li className="flex items-center space-x-3">
//               <FaUserGraduate className="text-blue-500 text-xl" />
//               <span>
//                 Have a bachelor's degree with an average of 50 percent or higher
//                 marks
//               </span>
//             </li>
//             <li className="flex items-center space-x-3">
//               <FaLaptopCode className="text-blue-500 text-xl" />
//               <span>
//                 Have a basic understanding of programming concepts and
//                 mathematics
//               </span>
//             </li>
//             <li className="flex items-center space-x-3">
//               <FaCalculator className="text-blue-500 text-xl" />
//               <span>Preferably, have 2+ years of professional experience</span>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ApplicationModal;

// src/pages/yourpage/ApplicationModal.jsx

import React, { useState } from "react";
import axios from "axios";
import Modal from "../../Other/Modal"; // updated import
import { FaUserGraduate, FaLaptopCode, FaCalculator } from "react-icons/fa";

const ApplicationModal = ({ isOpen, onClose, courseId,CourseName}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
  });

  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      alert("Please agree to the Privacy Policy before submitting.");
      return;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_LOGIN_API_BASEURL}/inquiry`,
        formData
      );

      const payload = { 
        courses: [courseId],
        courseName:CourseName, 
      };
      const token = JSON.parse(localStorage.getItem("token"));

      await axios.post(
        `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      await axios.post(
        `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=IN`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      alert("Application submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        experience: "",
      });
      setIsChecked(false);
      onClose();
    } catch (error) {
      console.error("Error submitting application:", error);
      alert("Failed to submit application. Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold text-center text-gray-900">
        Start Application
      </h2>
      <p className="mt-2 text-sm text-center text-gray-600">
        Please enter the following details to initiate your application for
        <strong> Advanced Executive Program In Applied Generative AI</strong>
        in partnership with IITM Pravartak.
      </p>

      <form className="mt-4 space-y-4" onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full mt-1 p-2 rounded-lg"
            placeholder="Enter your name"
          />
        </div>
        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full mt-1 p-2 rounded-lg"
            placeholder="Enter your email"
          />
        </div>
        <div>
          <div className="flex gap-2">
            <select className="w-24 px-2 py-2 border border-gray-300 rounded-md">
              <option value="IN">IN +91</option>
            </select>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone Number*"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Total Work Experience*
          </label>
          <select
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            className="w-full mt-1 p-2 border rounded-lg"
          >
            <option value="">Select experience</option>
            <option value="0">No experience</option>
            <option value="1">1-2 years</option>
            <option value="3">3-5 years</option>
            <option value="5">5+ years</option>
          </select>
        </div>

        <div className="flex items-start">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="!mt-1 !w-[10%]"
          />
          <span className="text-sm text-gray-600">
            By providing your contact details, you agree to our{" "}
            <a href="#" className="!text-blue-600 !hover:underline">
              Privacy Policy
            </a>
          </span>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="mt-4 bg-[#264b82] text-white p-2 rounded-lg font-semibold hover:bg-blue-700"
          >
            Proceed
          </button>
        </div>
      </form>

      <div className="w-full mt-6 border-t pt-4 text-sm">
        <h3 className="text-lg font-bold text-gray-900">Eligible Candidates</h3>
        <ul className="mt-4 space-y-4">
          <li className="flex items-center space-x-3">
            <FaUserGraduate className="text-blue-500 text-xl" />
            <span>
              Have a bachelor's degree with an average of 50 percent or higher
              marks
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <FaLaptopCode className="text-blue-500 text-xl" />
            <span>
              Have a basic understanding of programming concepts and mathematics
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <FaCalculator className="text-blue-500 text-xl" />
            <span>Preferably, have 2+ years of professional experience</span>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default ApplicationModal;
